const LOAStatusEnum = Object.freeze({
    MISSING: 'MISSING',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED'
});

export default LOAStatusEnum;
